"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Item_1 = require("./Item");

exports.List = function (_a) {
  var id = _a.id,
      className = _a.className,
      isOrdered = _a.isOrdered,
      isAlphabetical = _a.isAlphabetical,
      children = _a.children; // set matching jsx tag for unordered or ordered list element

  var Component = isOrdered ? "ol" : "ul";
  return React.createElement(Component, {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "list", className, isOrdered ? CSSPrefix_1.lsgPre + "list__ordered" : CSSPrefix_1.lsgPre + "list__unordered", isOrdered && isAlphabetical && CSSPrefix_1.lsgPre + "list__ordered-alphabetical"])
  }, children);
};

exports.List.Item = Item_1.Item;
exports.List.displayName = "List";